// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge-number[data-v-ef83d4ee]{min-width:35px;min-height:35px;background-color:#f1f1f1;display:inline-block;border-radius:55px;text-align:center;padding:7px 10px;font-size:22px;margin-bottom:18px;font-weight:700;box-shadow:0 1px 2px 1px rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = exports;
